import ConfigConstantsEdit from '@/components/configs/constants/edit/ConfigConstantsEdit.vue'

export default {
  name: 'ConfigConstantsList',
  data () {
    return {
      isMounted: false,
      loading: true,
      filterValues: [],
      configdata: []
    }
  },
  components: {
    ConfigConstantsEdit
  },
  computed: {
    tableHeaders () {
      const headers = {};
      headers.document_types = [
        { key: 'name', label: this.$t('general.file.document_type'), format: 'formatTranslation' },
        { key: 'code', label: this.$t('general.item.code') },
        { key: 'order', label: this.$t('general.item.order') }
      ];
      headers.comment_types = [
        { key: 'name', label: this.$t('comment.type'), format: 'formatTranslation' },
        { key: 'code', label: this.$t('general.item.code') },
        { key: 'order', label: this.$t('general.item.order') }
      ]
      if (this.canEdit) {
        headers.document_types.push({ key: 'actions', label: '', actions: [{ label: this.$t('menu.config.constants.document_types.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] });
        headers.comment_types.push({ key: 'actions', label: '', actions: [{ label: this.$t('menu.config.constants.comment_types.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] });
      }
      return headers;
    },
    tableActions () {
      const actions = { document_types: {}, comment_types: {} };
      if (this.canEdit) {
        actions.document_types.add = { title: this.$t('menu.config.constants.document_types.new') };
        actions.comment_types.add = { title: this.$t('menu.config.constants.comment_types.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    getTableData () {
      const self = this;
      this.loading = true;
      this.ApiRequest.request('config/get', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.configdata = self.getConfigData(response.data);
        }
        self.loading = false;
      });
    },
    getConfigData (data) {
      const items = {};
      Object.keys(this.tableHeaders).forEach(key => {
        if (data[key]) {
          items[key] = [];
          Object.keys(data[key]).forEach(id => {
            const val = data[key][id];
            val.id = id;
            items[key].push(val);
          });
        }
      });
      return items;
    },
    configUpdated (data) {
      this.loading = true;
      this.$store.commit('SAVE_CONFIG', data);
      this.configdata = this.getConfigData(data);
      this.loading = false;
    },
    editItem (el, key) {
      this.$refs.editElFrm.show(el, key);
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
